<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle" styleClass="confirm-dialog"
  appendTo="body"></p-confirmDialog>




<p-tabs value="/pages/CAT/Comparative-Review/Exception" id="Comparative-Details"
  class="comparative-details-tab nopadding">
  <p-tablist>
    @for(tab of tabPanel; track tab.route){
    <p-tab [value]="tab.route" [routerLink]="tab.route" class="flex items-center !gap-2 text-inherit">
      <span>{{ tab.label }}</span>
    </p-tab>
    }
  </p-tablist>
</p-tabs>
<div class="panelBlock nopadding">
  <router-outlet> </router-outlet>
</div>